'use strict';

let isActive = false;

const updateScreenZoomValue = () => {
    const zoomValue = Math.round(window.devicePixelRatio * 100);
    isActive = zoomValue >= 400;

    $('body').toggleClass('super-zoom', isActive);
};

updateScreenZoomValue();
window.addEventListener('resize', updateScreenZoomValue);

module.exports = {
    isActive
};
